import { find, has, orderBy } from 'lodash'

export const buildOutletCatalogGlobalCategories = (
  globalCategories = [],
  products = [],
  categoryDocs = []
) => {
  const groupedByGlobalId = {}

  products.forEach((product) => {
    const categoryDoc = find(categoryDocs, { id: product.categoryId })

    if (!categoryDoc?.globalCategoryId || !product.subcategoryId) {
      return
    }

    const subcategories = categoryDoc.subcategories || []
    let subcategory = subcategories.find((item) => String(item.id) === String(product.subcategoryId))

    if (!subcategory && product.subcategoryName) {
      subcategory = subcategories.find((item) => item.title === product.subcategoryName)
    }

    if (!subcategory) {
      return
    }

    const globalCategoryId = categoryDoc.globalCategoryId
    const categoryName = categoryDoc.name

    if (!groupedByGlobalId[globalCategoryId]) {
      groupedByGlobalId[globalCategoryId] = {}
    }

    if (!has(groupedByGlobalId[globalCategoryId], categoryName)) {
      groupedByGlobalId[globalCategoryId][categoryName] = []
    }

    const categoryItems = groupedByGlobalId[globalCategoryId][categoryName]
    let categoryItem = categoryItems.find((item) => String(item.categoryId) === String(categoryDoc.id))

    if (!categoryItem) {
      categoryItem = {
        name: categoryDoc.name,
        brandId: categoryDoc.brandId,
        categoryId: categoryDoc.id,
        subcategories: [],
      }
      categoryItems.push(categoryItem)
    }

    const hasSubcategory = categoryItem.subcategories.some(
      (item) => String(item.id) === String(subcategory.id)
    )

    if (!hasSubcategory) {
      categoryItem.subcategories.push(subcategory)
    }
  })

  const globalCategoryById = Object.fromEntries(
    globalCategories.map((globalCategory) => [globalCategory.id, globalCategory])
  )

  return orderBy(
    Object.entries(groupedByGlobalId)
      .map(([globalCategoryId, children]) => {
        const nonEmptyChildren = Object.fromEntries(
          Object.entries(children).filter(([, items]) =>
            items.some((item) => item.subcategories.length > 0)
          )
        )

        if (Object.keys(nonEmptyChildren).length === 0) {
          return null
        }

        const meta = globalCategoryById[globalCategoryId]

        return {
          id: globalCategoryId,
          name: meta?.name || globalCategoryId,
          order: meta?.order ?? 999,
          url: meta?.url,
          children: nonEmptyChildren,
        }
      })
      .filter(Boolean),
    ['order'],
    ['asc']
  )
}

export default buildOutletCatalogGlobalCategories
